import Request from './request'

const ClientOrder  = {
  getClientOrdersList(params, callback) {
    Request.get('client-orders', params).then(callback).catch(this.bad_answer)
  },
  getClientOrderInfo(order_id, callback) {
    Request.get('client-orders/' + order_id).then(callback).catch(this.bad_answer)
  },
  updateClientOrder(order_id, params, callback) {
    Request.put('client-orders/' + order_id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  createClientOrder(params, callback) {
    Request.post('client-orders', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeDevice(params, callback) {
    Request.post('client-order/remove-device', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getAvailableOrdersForSnapshot(fid, callback) {
    Request.get('client-order/available-orders-for-snapshot/' + fid).then(callback).catch(this.bad_answer)
  },
  copyClientOrder(order_id, callback) {
    Request.post('client-order/copy/' + order_id).then(callback).catch(this.bad_answer)
  },
  getClientOrderSimcards(order_id, callback) {
    Request.get('client-order/simcards/' + order_id).then(callback).catch(this.bad_answer)
  },
  getClientOrderDeviceTasks(order_id, callback) {
    Request.get('client-order/device-tasks/' + order_id).then(callback).catch(this.bad_answer)
  },
}

export default ClientOrder
